var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column",
      staticStyle: { "z-index": "1000" },
      attrs: { "data-testid": _vm.testId || "searchbar-root" },
    },
    [
      !_vm.advanced && _vm.vertical
        ? _c(
            "v-autocomplete",
            {
              key: _vm.filter,
              ref: "autocomplete",
              attrs: {
                placeholder: _vm.$t(_vm.placeholder),
                "prepend-inner-icon": _vm.icon,
                "hide-no-data": "",
                "hide-details": "",
                "return-object": "",
                "auto-select-first": "",
                "no-filter": "",
                clearable: "",
                items: _vm.searchItems,
                filled: _vm.filled,
                loading: _vm.loadingFilter || !_vm.dataSet,
                "search-input": _vm.filterValue,
                "menu-props": {
                  maxHeight: _vm.$vuetify.breakpoint.smAndDown ? 355 : 900,
                },
                disabled: !_vm.dataSet || _vm.disabled,
                "append-icon": _vm.advanced ? "" : "$dropdown",
                "input-attrs": { "data-testid": "searchbar-input" },
                direction: "vertical",
              },
              on: {
                "update:searchInput": function ($event) {
                  _vm.filterValue = $event
                },
                "update:search-input": function ($event) {
                  _vm.filterValue = $event
                },
                change: function ($event) {
                  return _vm.onAutoCompleteChange($event)
                },
                click: function ($event) {
                  return _vm.onInputClick()
                },
                focus: function ($event) {
                  return _vm.onInputFocus()
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item",
                    fn: function (data) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "w-100",
                            attrs: {
                              "data-testid": `searchbar-option-${data.item.type}`,
                            },
                          },
                          [
                            data.item.type === "player"
                              ? _c("PlayerSearchItem", {
                                  attrs: { player: data.item.value },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            data.item.type === "team"
                              ? _c("TeamSearchItem", {
                                  attrs: { team: data.item.value },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            data.item.type === "game"
                              ? _c("GameSearchItem", {
                                  attrs: { game: data.item.value },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            data.item.type === "league"
                              ? _c("LeagueSearchItem", {
                                  attrs: { league: data.item.value },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            data.item.type === "allResults"
                              ? _c("div", {}, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "primary--text font-weight-bold",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("searchbar.explore"))
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1337159764
              ),
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            },
            [
              _c("template", { slot: "progress" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-center" },
                  [
                    _c("v-progress-circular", {
                      staticClass: "mx-1",
                      attrs: {
                        size: 32,
                        color: "secondary",
                        indeterminate: "",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.advanced && !_vm.vertical
        ? _c(
            "v-menu",
            {
              key: `vertical-` + _vm.filter,
              ref: "menuSearchbarRef",
              attrs: {
                bottom: "",
                "offset-y": "",
                "nudge-bottom": "2",
                "min-width": "666",
                "open-on-click": false,
                "close-on-click": false,
                "close-on-content-click": false,
                value: _vm.menuVisible,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-autocomplete",
                          _vm._g(
                            _vm._b(
                              {
                                key: _vm.filter,
                                ref: "autocomplete",
                                attrs: {
                                  placeholder: _vm.$t(_vm.placeholder),
                                  "prepend-inner-icon": _vm.icon,
                                  "hide-no-data": "",
                                  "hide-details": "",
                                  "return-object": "",
                                  "auto-select-first": "",
                                  "no-filter": "",
                                  clearable: "",
                                  items: _vm.searchItems,
                                  filled: _vm.filled,
                                  loading: _vm.loadingFilter || !_vm.dataSet,
                                  "search-input": _vm.filterValue,
                                  "menu-props": { disabled: true },
                                  disabled: !_vm.dataSet || _vm.disabled,
                                  "append-icon": _vm.advanced
                                    ? ""
                                    : "$dropdown",
                                  "input-attrs": {
                                    "data-testid": "searchbar-input",
                                  },
                                  direction: "vertical",
                                },
                                on: {
                                  "update:searchInput": function ($event) {
                                    _vm.filterValue = $event
                                  },
                                  "update:search-input": function ($event) {
                                    _vm.filterValue = $event
                                  },
                                  change: function ($event) {
                                    return _vm.onAutoCompleteChange($event)
                                  },
                                  click: function ($event) {
                                    return _vm.onInputClick()
                                  },
                                  focus: function ($event) {
                                    return _vm.onInputFocus()
                                  },
                                  blur: function ($event) {
                                    return _vm.onInputBlur()
                                  },
                                },
                                model: {
                                  value: _vm.filter,
                                  callback: function ($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter",
                                },
                              },
                              "v-autocomplete",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c("template", { slot: "progress" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "mx-1",
                                    attrs: {
                                      size: 32,
                                      color: "secondary",
                                      indeterminate: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3061888644
              ),
            },
            [
              _vm._v(" "),
              _vm.searchItems.length
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column",
                      class: _vm.$vuetify.theme.dark ? "black" : "white",
                    },
                    [
                      _c("div", { staticClass: "d-flex flex-row" }, [
                        _c("div", { staticClass: "w-50" }, [
                          _c(
                            "div",
                            { staticClass: "px-4" },
                            [
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 primary--text font-weight-bold",
                                },
                                [_vm._v(_vm._s(_vm.$t("searchbar.players")))]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.playerSearchItems, function (item, i) {
                                return _c("PlayerSearchItem", {
                                  key: i,
                                  attrs: {
                                    player: item.value,
                                    allowRouter: "",
                                  },
                                })
                              }),
                              _vm._v(" "),
                              _c("v-divider"),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "w-50" }, [
                          _c(
                            "div",
                            { staticClass: "px-4" },
                            [
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 primary--text font-weight-bold",
                                },
                                [_vm._v(_vm._s(_vm.$t("searchbar.teams")))]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.teamSearchItems, function (item, i) {
                                return _c("TeamSearchItem", {
                                  key: i,
                                  attrs: { team: item.value, allowRouter: "" },
                                })
                              }),
                              _vm._v(" "),
                              _c("v-divider"),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "px-4" },
                            [
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 primary--text font-weight-bold",
                                },
                                [_vm._v(_vm._s(_vm.$t("searchbar.games")))]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.gameSearchItems, function (item, i) {
                                return _c("GameSearchItem", {
                                  key: i,
                                  attrs: { game: item.value, allowRouter: "" },
                                })
                              }),
                              _vm._v(" "),
                              _c("v-divider"),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "px-4" },
                            [
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 primary--text font-weight-bold",
                                },
                                [_vm._v(_vm._s(_vm.$t("searchbar.leagues")))]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.leagueSearchItems, function (item, i) {
                                return _c("LeagueSearchItem", {
                                  key: i,
                                  attrs: {
                                    league: item.value,
                                    allowRouter: "",
                                  },
                                })
                              }),
                              _vm._v(" "),
                              _c("v-divider"),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pa-3 lighten-1",
                          class: _vm.$vuetify.theme.dark ? "black" : "white",
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "elevation-0 px-4 monospace-font",
                              class: _vm.$vuetify.theme.dark
                                ? "secondary"
                                : "white",
                              attrs: {
                                "data-testid": "searchbar-explore-btn",
                                rounded: "",
                                block: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onAutoCompleteChange({
                                    type: "allResults",
                                  })
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("searchbar.explore")))]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.advanced
        ? _c("v-text-field", {
            attrs: {
              filled: _vm.filled,
              placeholder: "Placeholder",
              "hide-details": "",
            },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onExploreClick()
              },
            },
            model: {
              value: _vm.filter,
              callback: function ($$v) {
                _vm.filter = $$v
              },
              expression: "filter",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.advanced
        ? _c(
            "v-btn",
            {
              staticClass: "rounded-b",
              attrs: {
                color: "primary",
                block: "",
                tile: "",
                "x-small": "",
                disabled: !_vm.filter || _vm.filter.length < 3,
              },
              on: {
                click: function ($event) {
                  return _vm.onExploreClick()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("general.search")))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }